import React from 'react';
import { FaUniversity, FaMapMarkerAlt, FaGraduationCap, FaBook, FaUsers, FaBuilding, FaWifi, FaBed, FaUtensils, FaBookMedical } from 'react-icons/fa';
import { FaChalkboardTeacher } from 'react-icons/fa';

import './AboutUniversity.css';

const AboutUniversity = () => {
  return (
    <div className="about-university">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>À Propos de l'U2S</h1>
          <p>Découvrez notre histoire, notre mission et nos installations</p>
        </div>
      </section>
      
      {/* University Presentation */}
      <section className="university-presentation">
        <div className="presentation-container">
          <div className="presentation-text">
            <h2>Présentation de l'Université des Sciences de Sébikotane (U2S)</h2>
            <div className="info-grid">
              <div className="info-item">
                <FaUniversity className="info-icon" />
                <div>
                  <h3>Nom complet</h3>
                  <p>Université des Sciences de Sébikotane</p>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon">U2S</span>
                <div>
                  <h3>Sigle</h3>
                  <p>U2S</p>
                </div>
              </div>
              <div className="info-item">
                <FaMapMarkerAlt className="info-icon" />
                <div>
                  <h3>Localisation</h3>
                  <p>Sébikotane, Sénégal</p>
                </div>
              </div>
              <div className="info-item">
                <FaGraduationCap className="info-icon" />
                <div>
                  <h3>Tutelle</h3>
                  <p>Ministère de l'Enseignement supérieur, de la Recherche et de l'Innovation (MESRI)</p>
                </div>
              </div>
            </div>
            
            <p className="presentation-description">
              L'Université des Sciences de Sébikotane (U2S) est une université privée sénégalaise spécialisée dans les études islamiques et sciences de l'éducation. Fondée pour répondre aux besoins actuels et futurs du pays en matière de formation islamique, l'U2S s'engage à fournir une éducation de qualité dans un environnement académique stimulant.
            </p>
          </div>
          <div className="presentation-image">
            <div className="university-logo">
            </div>
          </div>
        </div>
      </section>
      
      {/* Mission Section */}
      <section className="mission-section">
        <div className="mission-container">
          <h2>Mission et Objectifs</h2>
          <p>L'U2S a pour ambition de former des cadres hautement qualifiés et de promouvoir la recherche et l'innovation locale. Nos objectifs principaux sont :</p>
          
          <div className="mission-grid">
            <div className="mission-card">
              <FaGraduationCap className="mission-icon" />
              <h3>Former des cadres qualifiés</h3>
              <p>Développer des compétences professionnelles et académiques chez nos étudiants</p>
            </div>
            <div className="mission-card">
              <FaBook className="mission-icon" />
              <h3>Promouvoir la recherche</h3>
              <p>Encourager l'innovation et la recherche scientifique dans nos domaines d'expertise</p>
            </div>
            <div className="mission-card">
              <FaUsers className="mission-icon" />
              <h3>Répondre aux besoins locaux</h3>
              <p>Adapter nos formations aux besoins spécifiques du marché sénégalais</p>
            </div>
            <div className="mission-card">
              <FaWifi className="mission-icon" />
              <h3>Innovation pédagogique</h3>
              <p>Intégrer les nouvelles technologies dans nos méthodes d'enseignement</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Programs Section */}
      <section className="programs-section">
        <div className="programs-container">
          <h2>Offre de Formation</h2>
          <p>L'U2S propose des formations de Licence alignées sur les standards du LMD (Licence - Master - Doctorat) et visant à répondre aux besoins du marché de l'emploi</p>
          
          <div className="program-cards">
            <div className="program-card">
              <div className="program-header">
                <FaBook className="program-icon" />
                <h3>Licence en Études Islamiques</h3>
              </div>
              <div className="program-body">
                <ul>
                  <li>Fiqh et Usul al-Fiqh</li>
                  <li>Tafsir et Sciences du Coran</li>
                  <li>Hadith et Sciences du Hadith</li>
                  <li>Histoire et Civilisation Islamique</li>
                </ul>
              </div>
              <div className="program-footer">
                <span>Durée: 3 ans</span>
              </div>
            </div>
            
            <div className="program-card">
              <div className="program-header">
                <FaChalkboardTeacher className="program-icon" />
                <h3>Licence en Sciences de l'Éducation</h3>
              </div>
              <div className="program-body">
                <ul>
                  <li>Pédagogie Générale</li>
                  <li>Didactique des Disciplines</li>
                  <li>Psychologie de l'Éducation</li>
                  <li>Administration Scolaire</li>
                </ul>
              </div>
              <div className="program-footer">
                <span>Durée: 3 ans</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Campus Section */}
      <section className="campus-section">
        <div className="campus-container">
          <h2>Campus et Infrastructures</h2>
          <p>Située à Sébikotane, l'U2S dispose d'un campus moderne (Campus Thiès), doté d'équipements pédagogiques de services complets pour les étudiants</p>
          
          <div className="campus-features">
            <div className="campus-feature">
              <div className="feature-icon"><FaBuilding /></div>
              <h3>Infrastructures Modernes</h3>
              <p>Salles de classe équipées et amphithéâtres</p>
            </div>
            <div className="campus-feature">
              <div className="feature-icon"><FaBookMedical /></div>
              <h3>Bibliothèques Numériques</h3>
              <p>Accès à des ressources numériques et bases de données académiques</p>
            </div>
          </div>
          
        </div>
      </section>
    </div>
  );
};

export default AboutUniversity;